import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import '@ionic/react/css/core.css';
import { IonButton, IonGrid, IonRow, IonCol, IonCard, IonAlert, useIonToast } from '@ionic/react';

const UploadInteressents = (state) => {
  const navigate = useNavigate();
  const [scannedInteressents, setInteressents] = useState(JSON.parse(localStorage.getItem('scanned-interessent')) || {});
  const [showAlert, setShowAlert] = useState(false);
  const eventData = JSON.parse(localStorage.getItem('event-data')) || false;

  const isLoggedIn = JSON.parse(localStorage.getItem('logged-in')) || false;

  const [present] = useIonToast();
  const presentToast = (custommessage, customclass, customduration = 2000) => {
      present({
          message: custommessage,
          duration: customduration,
          position: 'bottom',
          className: customclass,
      });
  };

  const lang = JSON.parse(localStorage.getItem('lang')) || {
    "en": {
      "scanned-entries": "Scanned Entries",
      "scanned-interessents": "Booth visitors",
      "upload": "Upload",
      "delete": "Delete",
      "popup-warning": "Warning!",
      "delete-message": "By pressing DELETE, stored data will be permanently deleted!",
      "popup-back": "Back",
      "delete-confirm": "Delete"
    }
  };

  let currLang = lang["en"];
  if (eventData) {
    currLang = lang[eventData.data.eventData.language];
  }

  const uploadInteressent = () => {
    console.log(scannedInteressents);

    let prepareURL = 'https://ukd.congress-registration.com/badge/classes/jsRequestsPython.php?code=hg78tOvkbvgZ0bn5hbvk&id=1&option=upload&value=interessents&scaner_id=' + isLoggedIn.id + '&data=' + JSON.stringify(scannedInteressents);

    console.log(prepareURL);
    fetch(prepareURL)
      .then(response => response.json())
      .then(json => uploadResponse(json))
      .catch(error => presentToast("Can't upload data to server!", "toast-error", 5000)); // 5000
  }

  const deletedInteressent = () => {
    setShowAlert(true);
    console.log(scannedInteressents);
  }

  const refreshPage = () => {
    navigate(0);
  }

  if (localStorage.getItem("refresh")) {
    console.log("refresh");
    localStorage.removeItem("refresh");
    refreshPage();
  }

  const uploadResponse = (input) => {
    if (input.response.status == "success") {
      localStorage.setItem('scanned-interessent', '{}');
      setInteressents({});
    } else {
      setInteressents(input.response.resume);
    }
    //console.log(response.response);
  }

  const doDelete = (status) => {
    //console.log(status);
    if (status == "confirm") {
      localStorage.setItem('scanned-interessent', '{}');
      setInteressents({});
    }
    setShowAlert(false);
  }

  return (
    <>
      {Object.keys(scannedInteressents).length > 0 && <IonCard class="loggedin">
        <h2>{currLang["scanned-interessents"]}</h2>
        <IonGrid>
          <IonRow>
            <IonCol><IonButton expand="full" style={{ height: '100%' }} onClick={uploadInteressent}>{currLang["upload"]}</IonButton></IonCol>
          </IonRow>
        </IonGrid>
      </IonCard>}
      {showAlert ? <IonAlert
        header={currLang["popup-warning"]}
        message={currLang["delete-message"]}
        isOpen={showAlert}
        buttons={[
          {
            text: currLang["popup-back"],
            role: 'cancel',
            handler: () => {

            },
          },
        ]}
        onDidDismiss={({ detail }) => doDelete(detail.role)}
      ></IonAlert> : null}
    </>
  );
}

export default UploadInteressents;
